/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { B2BUnit } from './B2BUnit';
import {
    B2BUnitFromJSON,
    B2BUnitFromJSONTyped,
    B2BUnitToJSON,
} from './B2BUnit';
import type { BudgetShallow } from './BudgetShallow';
import {
    BudgetShallowFromJSON,
    BudgetShallowFromJSONTyped,
    BudgetShallowToJSON,
} from './BudgetShallow';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';

/**
 * Cost center object.
 * @export
 * @interface B2BCostCenter
 */
export interface B2BCostCenter {
    /**
     * The original code of the cost center. Deprecated since 2005.
     * @type {string}
     * @memberof B2BCostCenter
     * @deprecated
     */
    originalCode?: string;
    /**
     * The name of the cost center
     * @type {string}
     * @memberof B2BCostCenter
     */
    name?: string;
    /**
     * Indication of whether the cost center is active. Deprecated since 2005. Read-only, used for display purposes.
     * @type {string}
     * @memberof B2BCostCenter
     * @deprecated
     */
    active?: string;
    /**
     * Boolean flag of whether the cost center is active.
     * @type {boolean}
     * @memberof B2BCostCenter
     */
    activeFlag?: boolean;
    /**
     * The code of the cost center
     * @type {string}
     * @memberof B2BCostCenter
     */
    code?: string;
    /**
     * 
     * @type {Currency}
     * @memberof B2BCostCenter
     */
    currency?: Currency;
    /**
     * 
     * @type {B2BUnit}
     * @memberof B2BCostCenter
     */
    unit?: B2BUnit;
    /**
     * Budgets assigned to this cost center
     * @type {Array<BudgetShallow>}
     * @memberof B2BCostCenter
     */
    assignedBudgets?: Array<BudgetShallow>;
}

/**
 * Check if a given object implements the B2BCostCenter interface.
 */
export function instanceOfB2BCostCenter(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function B2BCostCenterFromJSON(json: any): B2BCostCenter {
    return B2BCostCenterFromJSONTyped(json, false);
}

export function B2BCostCenterFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2BCostCenter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'originalCode': !exists(json, 'originalCode') ? undefined : json['originalCode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'activeFlag': !exists(json, 'activeFlag') ? undefined : json['activeFlag'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'currency': !exists(json, 'currency') ? undefined : CurrencyFromJSON(json['currency']),
        'unit': !exists(json, 'unit') ? undefined : B2BUnitFromJSON(json['unit']),
        'assignedBudgets': !exists(json, 'assignedBudgets') ? undefined : ((json['assignedBudgets'] as Array<any>).map(BudgetShallowFromJSON)),
    };
}

export function B2BCostCenterToJSON(value?: B2BCostCenter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'originalCode': value.originalCode,
        'name': value.name,
        'active': value.active,
        'activeFlag': value.activeFlag,
        'code': value.code,
        'currency': CurrencyToJSON(value.currency),
        'unit': B2BUnitToJSON(value.unit),
        'assignedBudgets': value.assignedBudgets === undefined ? undefined : ((value.assignedBudgets as Array<any>).map(BudgetShallowToJSON)),
    };
}

